import React, { useEffect, useState } from "react";
import {
  Calendar,
  Modal,
  List,
  Typography,
  Badge,
  Tag,
  Form,
  Input,
  Row,
  Col,
  Spin,
  Button,
  Alert,
} from "antd";
import moment from "moment";
import {
  ExclamationCircleTwoTone,
  FieldTimeOutlined,
  InfoCircleTwoTone,
  SwapRightOutlined,
} from "@ant-design/icons";
import { BsFillSquareFill, BsSquare } from "react-icons/bs"; //npm i react-icons
import { MdMoreTime } from "react-icons/md";
import { errorHandle, getMinute, useViewport } from "../Function";
import {
  GetListTotalTimeApi,
  listMyCalendarApi,
  MyDetailCalendarApi,
} from "../../api/usersApi";
import { ModalTaoDeNghi } from "./DeNghiChamCong";

const ModalDetailCongCC = ({ item, visible, onCancel, setDeNghiChamCong }) => {
  const [formCurrent] = Form.useForm();
  const [dataKhungGio, setDataKhungGio] = useState([]);

  const fetchDetail = () => {
    MyDetailCalendarApi({
      thoiGian: moment(item.ngay).format("YYYYMMDD"),
    }).then((r) => {
      setDataKhungGio(r.data);
      // console.log(r.data);
    });
  };

  useEffect(() => {
    if (item) {
      fetchDetail();
    }
  }, [visible]);

  useEffect(() => {
    if (item) {
      let checkValueOt_1 = "";
      if (item.gioVaoOT_1 === null && item.gioRaOT_1 === null) {
        checkValueOt_1 = "";
      } else {
        checkValueOt_1 =
          item.gioVaoOT_1.substr(0, 5) + " - " + item.gioRaOT_1.substr(0, 5);
      }
      let checkValueOt_2 = "";
      if (item.gioVaoOT === null && item.gioRaOT === null) {
        checkValueOt_2 = "";
      } else {
        checkValueOt_2 =
          item.gioVaoOT.substr(0, 5) + " - " + item.gioRaOT.substr(0, 5);
      }

      formCurrent.setFieldsValue({
        time_start: item.gioVao && item.gioVao.substr(0, 5),
        time_end: item.gioRa && item.gioRa.substr(0, 5),
        // cong:item.quydoicong,
        giochedo:
          item.gioVaoCD !== "" &&
          item.gioVaoCD !== null &&
          item.gioRaCD !== "" &&
          item.gioRaCD !== null
            ? item.gioVaoCD.substr(0, 5) + "-" + item.gioRaCD.substr(0, 5)
            : "",
        ot_1: checkValueOt_1,
        ot_2: checkValueOt_2,

        loaichamcong: item.loaiChamCong,
        giailao: item.gioGiailao + item.gioGiailao_1,
      });
    }
  }, [item, visible]);

  const onOk = () => {
    onCancel();
  };
  const onHideModal = () => {
    formCurrent.resetFields();
    onCancel();
  };
  return (
    item && (
      <Modal
        visible={visible}
        onCancel={onHideModal}
        title={
          <>
            Chi tiết công -{" "}
            {moment(item.ngay, "YYYY-MM-DD")
              .format("dddd, [ngày] DD/MM/YYYY")
              .replace(
                moment(item.ngay, "YYYY-MM-DD").format(
                  "dddd, [ngày] DD/MM/YYYY"
                )[0],
                moment(item.ngay, "YYYY-MM-DD")
                  .format("dddd, [ngày] DD/MM/YYYY")[0]
                  .toUpperCase()
              )}
          </>
        }
        onOk={onOk}
        footer={false}
        className={`${getClassTimekeeper(
          moment(item.ngay, "YYYY-MM-DD"),
          item
        )}-modal`}
        width={630}
      >
        {/*<div className={'row'}>*/}
        {/*<div className="col-12">*/}
        {/*    <p className="first_upper">{moment(item.ngay, "YYYY-MM-DD").format('dddd, [ngày] DD/MM/YYYY')}</p>*/}
        {/*</div>*/}
        {/*</div>*/}
        <Form
          form={formCurrent}
          autoComplete="off"
          size="small"
          // initialValues={{
          //     time_start:dataItem.gioVao,
          //     time_end:dataItem.gioRa,
          //     cong:dataItem.quydoicong,
          //     ot:dataItem.gioVao +"-"+ dataItem.gioRa,
          //     loaichamcong:dataItem.loaiChamCong,
          //     giailao:dataItem.giailao
          // }}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Khung giờ làm việc">
                {dataKhungGio.map((itemKhungGio, indexKhungGio) => (
                  <Tag
                    color="success"
                    key={indexKhungGio}
                    style={{ fontSize: 14 }}
                  >
                    {itemKhungGio.gioVao.toString().substr(0, 5) +
                      "-" +
                      itemKhungGio.gioRa.toString().substr(0, 5)}
                  </Tag>
                ))}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Giờ vào" name="time_start">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Giờ ra" name="time_end">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Chế độ" name="giochedo">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Row>
                <Col span={12}>
                  <Form.Item label="OT" name="ot_1">
                    <Input disabled={true} style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={11} offset={1}>
                  <Form.Item label="" name="ot_2">
                    <Input disabled={true} style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Loại chấm công" name="loaichamcong">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Giải lao" name="giailao">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          {item.type === "Error" && (
            <Row gutter={16}>
              <Col span={12}>
                <Button type={"primary"} danger onClick={setDeNghiChamCong}>
                  Tạo đề nghị chấm công
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Modal>
    )
  );
};

const getClassTimekeeper = (date, item) => {
  let result;
  if (item.isHoliday) {
    result = "timekeeper-holiday";
  } else if (item.isInsurance || item.isCDkhac) {
    result = "timekeeper-offMode";
  } else {
    switch (item.type) {
      case "holiday":
        result =
          date <= new Date() ? "timekeeper-holiday" : "timekeeper-undefined";
        break;
      case "Error":
        result =
          date <= new Date() ? "timekeeper-error" : "timekeeper-undefined";
        break;
      case "Success":
        result =
          date <= new Date() ? "timekeeper-success" : "timekeeper-undefined";
        break;
      case "offMode":
        result = "timekeeper-offMode";
        break;
      case "Future":
        result = "timekeeper-future";
        break;
      case "offDate":
        result = "timekeeper-off";
        break;
      default:
        result = "timekeeper-undefined";
        break;
      // default: result = date <= new Date() ? 'timekeeper-future' : 'timekeeper-undefined';break;
    }
  }

  return result || "";
};

const verifyIsToday = (date, item) => {
  if (moment(date).format("DDMMYYYY") === moment().format("DDMMYYYY")) {
    return "today";
  }
  return "";
};

const ModalChiTietPhepCN = ({ item, visible, onCancel, curSelectDate }) => {
  const [formCurrent] = Form.useForm();

  useEffect(() => {
    if (item) {
      formCurrent.setFieldsValue({
        cap: item["cap"],
        dung: item["dung"],
        conlai: item["conlai"],
        ghichu: item["ghichu"],
        dieuchinh: item["dieuchinh"],
      });
    }
  }, [item, visible]);

  const onOk = () => {
    onCancel();
  };
  const onHideModal = () => {
    formCurrent.resetFields();
    onCancel();
  };
  return (
    item && (
      <Modal
        visible={visible}
        onCancel={onHideModal}
        title={
          <>Chi tiết phép tháng {moment(curSelectDate).format("MM/YYYY")}</>
        }
        onOk={onOk}
        footer={false}
      >
        <Form form={formCurrent} autoComplete="off" size="small">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Cấp" name="cap">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Dùng" name="dung">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Điều chỉnh" name="dieuchinh">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Còn lại" name="conlai">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Ghi chú" name="ghichu">
                <Input disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    )
  );
};

export const Home = () => {
  const [currentSelectDate, setCurrentSelectDate] = useState(
    moment(new Date())
  );
  const [visibleDetailCong, setVisibleDetailCong] = useState(false);
  const [curDetailCong, setCurDetailCong] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingTotalTime, setLoadingTotalTime] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [dataChamcong, setDataChamcong] = useState([]);
  const [dataThongKe, setDataThongKe] = useState([]);
  const [dataChiTietPhep, setChiTietPhep] = useState([]);
  const [visibleChiTietPhepCN, setVisibleChiTietPhepCN] = useState(false);
  const [size_col_TK, setSize_col_TK] = useState([]);

  function getListData(value) {
    let data;
    data = dataChamcong.filter(
      (item) => new Date(item.ngay).getDate() === value.date()
    );
    // 290724 Nếu thay đổi múi giờ UTC -7 thì hiển thị giao diện sẽ lệch ngày
    // Kiểm tra lại toàn bộ web, convert múi giờ về UTC +7 với xử lý
    return data[0] || "";
  }
  const fetchData = (params = {}) => {
    setLoading(true);
    listMyCalendarApi(params)
      .then((r) => {
        setDataChamcong(r.data);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setDataChamcong([]);
        setLoading(false);
      });

    setLoadingTotalTime(true);
    GetListTotalTimeApi(params)
      .then((r) => {
        // console.log(r.data);
        let newDataTK = [];
        if (r.data.length > 0) {
          newDataTK.push({
            id: 1,
            ten: "Tổng ngày nghỉ tiêu chuẩn trong tháng",
            giatri: r.data[0].tongNgayNghiTrongThang,
            color: "",
          });
          newDataTK.push({
            id: 5,
            ten: "Số ngày nghỉ vượt mức",
            giatri: r.data[0].soNgayNghiVuotMuc,
            color: "#ffbe17",
          });
          newDataTK.push({
            id: 2,
            ten: "Số ngày phép còn lại trong tháng",
            giatri: <a>{r.data[0].phepConlai["conlai"]}</a>,
            color: "#37afff",
          });
          newDataTK.push({
            id: 3,
            ten: "Tổng ngày tăng ca",
            giatri: r.data[0].tongGioOT[1],
            color: "",
          });
          newDataTK.push({
            id: 6,
            ten: "Số công thực làm",
            giatri: r.data[0].soNgayCong,
            color: "",
          });
          newDataTK.push({
            id: 7,
            ten: "Công thực nhận",
            giatri: r.data[0].tongCongTrongThang,
            color: "",
          });
          // newDataTK.push({id:6, ten: "Số công thực nhận", giatri:r.data[0].congThucNhan})
          // newDataTK.push({id:3, ten: "Tổng giờ tăng ca", giatri:r.data[0].tongGioOT[0]})
          // newDataTK.push({id:4, ten: "Số lần vi phạm trong tháng", giatri:r.data[0].soLanVipham, color: '#f52a2a'})
          // newDataTK.push({id:5, ten: "Số buổi nghỉ trong tháng", giatri:r.data[0].sobuoiNghiTrongThang, color: '#ffbe17'})
          // newDataTK.push({id:7, ten: "Số công chuẩn", giatri:r.data[0].soCongChuan})
        }
        setDataThongKe(newDataTK);
        setChiTietPhep(r.data[0].phepConlai);
        setLoadingTotalTime(false);
      })
      .catch((err) => {
        errorHandle(err);
        setDataThongKe([]);
        setLoadingTotalTime(false);
      });
  };

  useEffect(() => {
    if (currentSelectDate === null) {
      setCurrentSelectDate(moment(new Date()));
      fetchData({ thoiGian: moment(new Date()).format("YYYYMM") });
    } else {
      fetchData({ thoiGian: moment(currentSelectDate).format("YYYYMM") });
    }
  }, [currentSelectDate]);

  // useEffect(()=>{
  //     fetchData({thoiGian: moment(currentSelectDate).format('YYYYMM')})
  // },[currentSelectDate])

  function dateCellRender(value) {
    const item = getListData(value);
    const getClassItem =
      getClassTimekeeper(value, item) + " " + verifyIsToday(value, item);
    return item !== "" &&
      currentSelectDate._d.getMonth() === value._d.getMonth() ? (
      item.type === "offMode" ? (
        <div
          onClick={() => onViewItem(item)}
          key={item.id}
          className={`timekeeper-date-cell ${getClassItem} row zoom`}
        >
          <div className="col-6">{value.format("DD/MM")}</div>
          <div>
            {item.ghichu !== "" && (
              <>
                <SwapRightOutlined className="styleAntIcon_1" /> {item.ghichu}
              </>
            )}
          </div>
          <br />
          <br />
        </div>
      ) : (
        <div
          onClick={() => onViewItem(item)}
          key={item.id}
          className={`timekeeper-date-cell ${getClassItem} zoom`}
        >
          <div className="row">
            <div className="col-12">{value.format("DD/MM")}</div>
          </div>
          <span title="Giờ vào - Giờ ra">
            <FieldTimeOutlined className="styleAntIcon_1" />
            {item.checkDenghi ? (
              <span style={{ color: "red" }}>
                {item.gioVaoDN ? item.gioVaoDN.substring(0, 5) : ""} -{" "}
                {item.gioRaDN ? item.gioRaDN.substring(0, 5) : ""}{" "}
                <InfoCircleTwoTone twoToneColor={"red"} />
              </span>
            ) : item.isInsurance || item.isCDkhac ? (
              <span>
                {item.gioVaoCD ? item.gioVaoCD.substring(0, 5) : ""} -{" "}
                {item.gioRaCD ? item.gioRaCD.substring(0, 5) : ""}
              </span>
            ) : (
              <span>
                {item.gioVao ? item.gioVao.substring(0, 5) : ""} -{" "}
                {item.gioRa ? item.gioRa.substring(0, 5) : ""}
              </span>
            )}
          </span>
          <br />
          <span>
            {item.gioVaoOT !== null || item.gioVaoOT_1 !== null ? (
              <>
                <MdMoreTime className="styleAntIcon_1 anticon" />
                OT {item.phutdangky} phút
              </>
            ) : (
              ""
            )}
            &nbsp;
          </span>
          <div>
            {item.ghichu !== "" ? (
              <>
                <SwapRightOutlined className="styleAntIcon_1" /> {item.ghichu}
              </>
            ) : (
              ""
            )}
            &nbsp;
          </div>
        </div>
      )
    ) : (
      currentSelectDate._d.getMonth() === value._d.getMonth() && (
        <div
          className={`timekeeper-date-cell ${getClassItem} timekeeper-default`}
        >
          <span>{value.format("DD/MM")}</span>
          <br />
          <br />
          <br />
          <p className={"mb-0"}>
            <span>&nbsp;</span>
          </p>
        </div>
      )
    );
  }

  function monthCellRender(value) {
    return <span className="text-capitalize">{value.format("MMMM")}</span>;
  }

  const onViewItem = (item) => {
    setCurDetailCong(item);
    setVisibleDetailCong(true);
  };
  const onSelect = (value) => {
    // console.log(value);
  };

  const onSelectMonth = (value) => {
    setLoading(true);
    setCurrentSelectDate(moment(new Date(value._d)));
    // listMyCalendarApi({thoiGian:value.format("YYYYMM")})
    // .then(res=>{
    //     setCurrentSelectDate(moment(new Date(value._d)))
    // }).catch(err => {
    //     errorHandle(err);
    //     setDataChamcong([])
    //     setLoading(false);
    // });
  };

  const onPanelChange = (date) => {
    setCurrentSelectDate(moment(new Date(date._d)));
  };

  // useEffect(()=>{
  //     // fetchMyCalendar();
  // },[])

  const disabledDate = (current) => {
    return (
      current &&
      new Date(current._d).getMonth() !==
        new Date(currentSelectDate._d).getMonth()
    );
  };

  const viewPort = useViewport();
  useEffect(() => {
    // const isLaptop = viewPort.width <= 1024;
    // console.log(isLaptop);
    if (viewPort.width <= 1024) {
      setSize_col_TK([18, 6]);
      return;
    }
    if (viewPort.width <= 1536) {
      setSize_col_TK([19, 5]);
      return;
    }
    if (viewPort.width <= 1920) {
      setSize_col_TK([20, 4]);
      return;
    }
  }, []);

  return (
    <>
      {/*start page title*/}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Bảng chấm công cá nhân</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>Cá nhân</a>
                </li>
                <li className="breadcrumb-item active">
                  Bảng chấm công cá nhân
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/*end page title*/}

      <div className="row home">
        <div className="col-lg-3 col-xl-3 col-xxl-2">
          <div className="row">
            <Spin spinning={loading}>
              <Calendar
                defaultValue={moment(new Date())}
                onPanelChange={onPanelChange}
                monthFullCellRender={monthCellRender}
                mode={"year"}
                className={"styleMonthCel"}
                onSelect={onSelectMonth}
              />
            </Spin>
          </div>
          <div style={{ marginBottom: "25px" }}></div>
          <div className="row">
            <List
              header={
                <Row>
                  <Col span={size_col_TK[0]}>
                    <Typography.Title level={5}>
                      Thống kê dữ liệu công{" "}
                    </Typography.Title>
                  </Col>
                  <Col span={size_col_TK[1]}>
                    <Typography.Text code strong title="Số công chuẩn">
                      <span style={{ color: "#3151ab" }}>24</span>
                    </Typography.Text>
                  </Col>
                </Row>
                // <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                //     <Typography.Title level={5}>Thống kê dữ liệu công </Typography.Title>
                //     <Typography.Text code strong title="Số công chuẩn"><span style={{color: "#3151ab"}}>24</span></Typography.Text>
                // </div>
              }
              bordered
              size="small"
              dataSource={dataThongKe}
              loading={loadingTotalTime}
              className="styleThongke"
              renderItem={(item, key) => (
                <List.Item style={{ display: "block" }}>
                  <Row>
                    <Col span={size_col_TK[0]}>{item.ten}</Col>
                    <Col span={size_col_TK[1]}>
                      {key == 2 ? ( //Số phép còn lại trong tháng
                        <Typography.Text
                          code
                          strong
                          onClick={() => setVisibleChiTietPhepCN(true)}
                          title="Chi tiết phép cá nhân"
                        >
                          <span
                            style={{
                              color: item.color,
                              borderBottom: "0.5px solid",
                            }}
                          >
                            {item.giatri}
                          </span>
                        </Typography.Text>
                      ) : (
                        <Typography.Text code strong>
                          <span style={{ color: item.color }}>
                            {item.giatri}
                          </span>
                        </Typography.Text>
                      )}
                    </Col>
                  </Row>
                </List.Item>
              )}
            />
          </div>
        </div>
        <div className="col-lg-9 col-xl-9 col-xxl-10">
          <Spin spinning={loading}>
            <Calendar
              defaultValue={moment(new Date())}
              value={currentSelectDate}
              dateFullCellRender={dateCellRender}
              onPanelChange={onPanelChange}
              onSelect={onSelect}
              disabledDate={disabledDate}
            />
          </Spin>
          <div style={{ textAlign: "right" }}>
            <Badge>
              <ExclamationCircleTwoTone
                className="styleBorder_1"
                twoToneColor={"#f52a2a"}
              />
              Chờ phê duyệt đề nghị chấm công
            </Badge>
            <Badge>
              <BsFillSquareFill className="styleBorder_1 timekeeper-offMode-note" />
              {/* <BsFillSquareFill className="styleBorder_1" style={{color: lsColor[0].color}} /> */}
              Ngày nghỉ chế độ
            </Badge>
            <Badge>
              <BsFillSquareFill className="styleBorder_1 timekeeper-error-note" />
              Chấm công sai
            </Badge>
            <Badge>
              <BsFillSquareFill className="styleBorder_1 timekeeper-success-note" />
              Chấm công đúng
            </Badge>
            <Badge>
              <BsFillSquareFill className="styleBorder_1 timekeeper-off-note" />
              Ngày nghỉ
            </Badge>
            <Badge>
              <BsSquare className="styleBorder_1 timekeeper-undefined-note" />
              Chưa có lịch làm việc
            </Badge>
            <Badge>
              <BsSquare className="styleBorder_1 timekeeper-future-note" />
              Chưa đến ca làm việc
            </Badge>
            <Badge>
              <BsFillSquareFill className="styleBorder_1 timekeeper-holiday-note" />
              Công Lễ/Tết
            </Badge>
          </div>

          {/* <List
                        grid={{ xs: 8, sm: 16, md: 24 }}
                        size="large"
                        dataSource={dataChuThich}
                        style={{display: "flex", justifyContent: "flex-end"}}
                        renderItem={item => (
                            <List.Item
                                key={item.id}
                                actions={[<a key="list-loadmore-edit">edit</a>]}
                            >

                                <Badge color={item.color} text={item.ten} />
                                <PlayCircleOutlined style={{ fontSize: 16 }} />
                                <div>{item.ten}</div>

                            </List.Item>
                        )}
                    /> */}
        </div>
      </div>
      {/*end row*/}
      <ModalDetailCongCC
        visible={visibleDetailCong}
        onCancel={() => setVisibleDetailCong(false)}
        item={curDetailCong}
        setDeNghiChamCong={() => setIsShowModal(true)}
      />
      <ModalTaoDeNghi
        visible={isShowModal}
        onCancel={() => setIsShowModal(false)}
        updateData={() =>
          fetchData({ thoiGian: moment(currentSelectDate).format("YYYYMM") })
        }
        itemData={curDetailCong}
      />
      <ModalChiTietPhepCN
        visible={visibleChiTietPhepCN}
        onCancel={() => setVisibleChiTietPhepCN(false)}
        item={dataChiTietPhep}
        curSelectDate={currentSelectDate}
      />
    </>
  );
};
